export const i18nKeyPrefix: string = 'HEADER'
